import axios from 'axios'
import Cookie from 'js-cookie'

const options = {
  baseURL: `/`,
  // timeout: 1000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

const axiosClient = axios.create(options)

axiosClient.interceptors.request.use(function (request) {
  const kudenixTokenCookie = Cookie.get('ad-kudenix-token')
  if (kudenixTokenCookie) {
    request.headers['kudenix-token'] = kudenixTokenCookie
  }
  return request
})

axiosClient.interceptors.response.use(
  function (response) {
    console.log("response", response)
    if (!response) return { error: true }

    return response
  },
  function (error) {
    console.log('error', error)
    if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      console.log('Request timed out')
      console.log('Request timed out', Promise.resolve({ error: true, msg: 'timeout' }))
      return Promise.resolve({ error: true, msg: 'timeout' })
    }
    
    let res = error.response
    if (res.status == 401) {
      window.location.href = '/logout'
      console.log('401', res.status, res)
    }
    console.error('Looks like there was a problem. Status Code: ' + res.status)
    
    return Promise.reject(error)
  }


)

export default axiosClient
